/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Canceltitle2Inputs */

const zh_adminsubs_canceltitle2 = /** @type {(inputs: Adminsubs_Canceltitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消订阅`)
};

const en_adminsubs_canceltitle2 = /** @type {(inputs: Adminsubs_Canceltitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Subscription`)
};

const es_adminsubs_canceltitle2 = /** @type {(inputs: Adminsubs_Canceltitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar suscripción`)
};

/**
* | output |
* | --- |
* | "Cancel Subscription" |
*
* @param {Adminsubs_Canceltitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_canceltitle2 = /** @type {((inputs?: Adminsubs_Canceltitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Canceltitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_canceltitle2(inputs)
	if (locale === "en") return en_adminsubs_canceltitle2(inputs)
	return es_adminsubs_canceltitle2(inputs)
});
export { adminsubs_canceltitle2 as "adminSubs_cancelTitle" }